// src/routes/routeConfig.ts

// Routes that should not display the NavBar (public / pre-auth / onboarding).
export const hideNavBarRoutes = [
  '/',
  '/login',
  '/signup',
  '/forgot-password',
  '/onboarding/role-selection',
  '/onboarding/hospital-clinic',
  '/onboarding/insurance',
  '/onboarding/laboratory',
  '/features',
  '/pricing',
  '/integrations',
  '/nhis-integration',
  '/help',
  '/contact',
  '/privacy',
  '/terms',
];